/**
 * Init dropdown-menus
 */
var dropdown_menus = document.querySelectorAll('.js-navigation');
for (var i = 0; i < dropdown_menus.length; i++) {
  component_dropdown_menu({
    desktop_min_width: 1200,
    menu: dropdown_menus[i]
  });
}

/**
 * Init mobile menu
 */
component_mobile_menu({
  menu:     document.querySelector('.js-mobile-menu'),
  site:     document.querySelector('.js-page'),
  toggles:  document.querySelectorAll('.js-menu-toggle')
});

/**
 * Init sub-pages navigation
 */
if (document.getElementById('sub-pages')) {
  aucor_sub_pages_navigation(document.getElementById('sub-pages'));
}

/**
 * Toggle active items initially
 */
var initial_sub_pages_active = document.querySelectorAll('.sub-pages-list, .current_page_ancestor');
if (initial_sub_pages_active.length) {
  for (var i = 0; i < initial_sub_pages_active.length; i++) {
    initial_sub_pages_active[i].classList.add('active');
  }
}

/**
 * Lang menu
 */
var lang_menu = function() {

  var lang_dropdown = document.querySelector('.js-lang-dropdown');
  var lang_toggle = document.querySelector('.js-lang-dropdown button');
  if (lang_dropdown && lang_toggle) {
    lang_toggle.addEventListener('click', function(e) {
      lang_dropdown.classList.toggle('lang-dropdown--open');
    });
  }
};
lang_menu();

(function($) {


  // languages dropdown menu
  var language_toggle = $('.language-selector-button');
  var language_menu = $('#language-selector-menu');

  // toggle menu
  language_toggle.click(function() {
    if(language_toggle.hasClass('active')) {
      language_toggle.removeClass('active').attr('aria-expanded', 'false');
      language_menu.removeClass('active');
    } else {
      language_toggle.addClass('active').attr('aria-expanded', 'true');
      language_menu.addClass('active');
    }
  });

  // search toggle
  var search_toggle = $('.search-toggle-wrapper'),
      search_form = $('.search-form-wrapper'),
      search_field = $('.search-field'),
      search_close = search_form.find('.close-x');
  search_toggle.on('click', function() {
    search_form.addClass('shown');
    search_field.focus();
  });
  search_close.on('click', function() {
    search_form.removeClass('shown');
  });
  // hero-content showup. Opacity is set to 0 in _front-page.scss

  // hero-content close
  if (Cookies.get('hyksin-hero-content-closed') !== 'closed') {
    $('#notice').show();
  }
  $('.close').click(function(){
    if (Cookies.get('hyksin-hero-content-closed') !== 'closed') {
      Cookies.set('hyksin-hero-content-closed', 'closed', { expires: 7 });
    }
    $('#notice').hide();
  });

  //hyphenate.js
  $('p, h2, li').hyphenate('fi');

  //Request-tabs in Info-page
  var $wrapper = $('.request-tabs'),
      $allTabs = $wrapper.find('.tab-content > div'),
      $tabMenu = $wrapper.find('.tab-menu li');

  $allTabs.not(':first-of-type').hide();

  $tabMenu.each(function(i) {
    $(this).attr('data-tab', 'tab'+i);
  });

  $allTabs.each(function(i) {
    $(this).attr('data-tab', 'tab'+i);
  });

  $tabMenu.on('click', function() {
    var dataTab = $(this).data('tab'),
        $getWrapper = $(this).closest($wrapper);

    $getWrapper.find($tabMenu).removeClass('active');
    $(this).addClass('active');

    $getWrapper.find($allTabs).hide();
    $getWrapper.find($allTabs).filter('[data-tab='+dataTab+']').show();
  });

  // Select and scroll to tab with url hash
  var param = window.location.hash.substring(1);

  if (param) {
    $tabMenu.filter('[data-tab=' + param + ']').trigger('click');

    $('html, body').animate({
      scrollTop: $wrapper.offset().top
    }, 600);
  }
})(jQuery);

/**
 * Table front-end
 */

/**
 * Make tables responsive
 */
let responsive_tables_in_content = function() {

  const tables = document.querySelectorAll('.site-main table');
  if (tables) {
    for (var i = 0; i < tables.length; i++) {

      // add modifier class to affected table
      tables[i].classList.add('table-responsive');

      // create new wrapper
      var wrapper = document.createElement('div');

      // take all classes from table
      wrapper.setAttribute('class', tables[i].getAttribute('class'));

      // reset table classes
      tables[i].removeAttribute('class');

      // wrap the table
      tables[i].parentNode.insertBefore(wrapper, tables[i]);
      wrapper.appendChild(tables[i]);

    }
  }

};

document.addEventListener('DOMContentLoaded', () => {
  responsive_tables_in_content();
});
